import axios from 'axios'
import { anqicmsConfig } from '@/config/anqicms'

const http = axios.create({
  baseURL: anqicmsConfig.apiBase,
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json'
  }
})

http.interceptors.response.use(
  response => {
    const body = response.data
    if (body && typeof body.code !== 'undefined' && body.code !== 0) {
      const err = new Error(body.msg || '接口请求失败')
      err.code = body.code
      return Promise.reject(err)
    }
    return body
  },
  error => {
    const message = error.response?.data?.msg || error.message || '网络请求失败'
    return Promise.reject(new Error(message))
  }
)

export default http
